import React from "react";

import UserComments from "../../molecules/UserComments";
import ProfileContainer from "../../rows/ProfileContainer";

const CommentsPage = () => (
  <ProfileContainer type="comments" hideTopAd={true}>
    <UserComments />
  </ProfileContainer>
);

export { CommentsPage };
